<template>
  <div>
    <div class="language-localize language-active" @click="open">
      <icon-flag-base width="18"><component :is="localesFlags[currentLocale.locale]"/></icon-flag-base>
      <div class="language-arrow">
        <icon-base class="language-arrow-down" width="18" height="18"><icon-chevron-down/></icon-base>
      </div>
    </div>

    <div class="language-localize language-list" v-show="opened">
      <div class="language-arrow">
        <icon-base class="language-arrow-up" width="18" height="18"><icon-chevron-up/></icon-base>
      </div>
      <a class="language-item active" :href="currentLocale.href" :key="currentLocale.locale">
        <icon-flag-base width="18"><component :is="localesFlags[currentLocale.locale]"/></icon-flag-base>
      </a>
      <a class="language-item active" :href="locale.href" v-for="locale in otherLocales" :key="locale.locale">
        <icon-flag-base width="18"><component :is="localesFlags[locale.locale]"/></icon-flag-base>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import IconBase from './IconBase.vue';
import IconFlagBase from './icons/flags/IconFlagBase.vue';
import IconFlagBy from './icons/flags/IconFlagBy.vue';
import IconFlagKz from './icons/flags/IconFlagKz.vue';
import IconFlagRu from './icons/flags/IconFlagRu.vue';
import IconFlagUa from './icons/flags/IconFlagUa.vue';
import IconFlagBr from './icons/flags/IconFlagBr.vue';
import IconFlagAu from './icons/flags/IconFlagAu.vue';
import IconChevronDown from './icons/IconChevronDown.vue';
import IconChevronUp from './icons/IconChevronUp.vue';

export default {
  name: 'app-language-select',

  components: {
    IconBase,
    IconFlagBase,
    IconFlagBy,
    IconFlagKz,
    IconFlagRu,
    IconFlagUa,
    IconFlagBr,
    IconFlagAu,
    IconChevronDown,
    IconChevronUp
  },

  props: {},

  data() {
    return {
      opened: false,
      localesFlags: {
        'by': 'icon-flag-by',
        'kz': 'icon-flag-kz',
        'ru': 'icon-flag-ru',
        'ua': 'icon-flag-ua',
        'br': 'icon-flag-br',
        'au': 'icon-flag-au',
		'de': 'icon-flag-au',
      }
    };
  },

  computed: {
    ...mapState(['locales', 'currentLocale']),

    otherLocales() {
      this.siteUrl()
      return this.locales.filter((item) => item.locale !== this.currentLocale.locale);
    },
  },

  methods: {
    open(e) {
      e.stopPropagation();
      this.opened = true;
      const bodyClickHandler = () => {
        this.opened = false;
        document.body.removeEventListener('click', bodyClickHandler);
      }
      document.body.addEventListener('click', bodyClickHandler);
    }
  }
}
</script>

<style scoped>
  .language-localize {
    display: flex;
    align-items: center;
    width: 60px;
    border-radius: 3px;
    cursor: pointer;
  }

  .language-active {
    padding: 5px 10px;
  }

  .language-active:hover {
    background-color: #ffffff;
  }

  .language-arrow {
    margin-left: 5px;
  }

  .language-arrow-up {
    color: #3c91e6;
  }

  .language-active:hover .language-arrow-down {
    color: #3c91e6;
  }

  .language-list {
    position: absolute;
    top: 0;
    flex-direction: column;
    align-items: flex-start;
    background-color: #ffffff;
    box-shadow: 0px 5px 15px 0px rgba(6, 19, 50, 0.15);
    z-index: 1;
  }

  .language-list .language-arrow {
    position: absolute;
    right: 10px;
    top: 5px;
  }

  .language-item {
    width: 100%;
    padding: 5px 10px;
    cursor: pointer;
  }

  .language-item.active {
    display: flex;
    align-items: center;
  }

  .language-arrow:hover + .language-item,
  .language-item:hover {
    background-color: #3c91e6;
  }

  .language-item:active {
    background-color: #29629c;
  }

  @media (max-width: 767px) {
    .language-arrow {
      margin: 0;
    }

    .language-localize {
      width: 45px;
    }

    .language-list .language-arrow {
      right: 5px;
    }

    .language-active,
    .language-item {
      padding: 5px;
    }
  }
</style>